import API from './api';

export default class EmailTemplateApi {
  static getList(params) {
    return API.get('/advertisers/email_templates', params);
  }
}
